/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ProductCard } from '@/components/blocks/HelloRetailProductCard';
import { ContentContext } from '@/data/context/content';
import { Grid } from '@mui/material';
import { FC, useContext } from 'react';
import { gridItemProductCardSx } from '../../CatalogEntryList/styles/productGrid';
import { cardNameSx } from '../../CatalogEntryList/styles/container';
import { HelloRetailResultsHeader } from './HelloRetailResultsHeader';
import { useHelloRetailSearch } from '@/data/Content/HelloRetailSearch';
import { HelloRetailCategoryList } from '../../Header/parts/HelloRetail/CategoryList';

export const HelloRetailProductGrid: FC = () => {
	const {
		products,
		resultCount,
		helloRetailClickTracking
	} = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;
	return (
		<Grid container>
			<Grid container>
				<Grid item width="100%">
					<HelloRetailResultsHeader total={resultCount} />
				</Grid>
			</Grid>
			<Grid container>
				<Grid
					container
					item
					spacing={3}
					alignItems="stretch"
					id="catalog-entry-list-product-grid"
					data-testid="catalog-entry-list-product-grid"
				>
					{products?.map((product, index) => (
						<Grid
							item
							xs={12}
							sm={6}
							md={4}
							lg={3}
							key={`${product.id}-${product.thumbnail}-${index}`}
							display="flex"
							sx={gridItemProductCardSx}
						>
							<ProductCard
								product={product}
								styles={{ cardNameSx }}
								imgLoading={index < 4 ? 'eager' : 'lazy'}
								clickAction={helloRetailClickTracking}
							/>
						</Grid>
					))}
				</Grid>
			</Grid>
			<Grid container>
				<Grid item width="100%">
					<HelloRetailResultsHeader total={resultCount} />
				</Grid>
			</Grid>
		</Grid>
	);
};
